/**
 * Utility to check contacts table structure and constraints
 */

import { supabase } from '../lib/supabase';

const checkContactsTable = async () => {
  console.log('=== CHECKING CONTACTS TABLE STRUCTURE ===');
  
  try {
    // Check if we can manually set the role field
    console.log('1. Testing direct role field update...');
    
    const testContactId = 4918;
    
    // Try a very simple update with just the role
    const { data: directUpdate, error: directError } = await supabase
      .from('contacts')
      .update({ role: 'Admin' })
      .eq('id', testContactId)
      .select('id, role')
      .single();
      
    console.log('Direct role update result:', {
      data: directUpdate,
      error: directError,
      role_value: directUpdate?.role
    });
    
    // Try updating a different field to see if the issue is specific to role
    console.log('\n2. Testing update of a different field...');
    const { data: nameUpdate, error: nameError } = await supabase
      .from('contacts')
      .update({ notes: `Test update ${Date.now()}` })
      .eq('id', testContactId)
      .select('id, notes, role')
      .single();
      
    console.log('Name field update result:', {
      data: nameUpdate,
      error: nameError,
      notes_updated: nameUpdate?.notes?.includes('Test update'),
      role_still_null: nameUpdate?.role === null
    });
    
    // Check if there are any contacts with non-null roles
    console.log('\n3. Checking for contacts with non-null roles...');
    const { data: contactsWithRoles, error: rolesError } = await supabase
      .from('contacts')
      .select('id, name, role')
      .not('role', 'is', null)
      .limit(5);
      
    console.log('Contacts with roles:', {
      count: contactsWithRoles?.length || 0,
      sample: contactsWithRoles,
      error: rolesError
    });
    
    // Try to check the table schema
    console.log('\n4. Checking table schema...');
    const { data: schemaInfo, error: schemaError } = await supabase
      .rpc('get_column_info', { table_name: 'contacts' });
      
    if (schemaError) {
      console.log('Could not get schema info:', schemaError.message);
    } else {
      console.log('Schema info:', schemaInfo);
    }
    
    // Check if we can insert a contact with a role
    console.log('\n5. Testing insert with role...');
    const testContactData = {
      name: `Test Contact ${Date.now()}`,
      email: `test${Date.now()}@test.com`,
      role: 'Admin',
      client_id: 1616
    };
    
    const { data: insertResult, error: insertError } = await supabase
      .from('contacts')
      .insert(testContactData)
      .select('id, name, role')
      .single();
      
    console.log('Insert with role result:', {
      data: insertResult,
      error: insertError,
      role_preserved: insertResult?.role === 'Admin'
    });
    
    // Clean up test contact
    if (insertResult?.id) {
      await supabase
        .from('contacts')
        .delete()
        .eq('id', insertResult.id);
      console.log('Cleaned up test contact');
    }
    
    console.log('\n=== CONTACTS TABLE CHECK COMPLETE ===');
    
  } catch (error) {
    console.error('Check failed:', error);
  }
};

// Make it available in browser console
if (typeof window !== 'undefined') {
  window.checkContactsTable = checkContactsTable;
  console.log('Contacts table checker available: window.checkContactsTable()');
}

export default checkContactsTable;